import { map } from 'lodash/fp';
import { Component } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { getSortedScopes } from '../selectors';
import { ContentWrapper } from './style';
import ScopeNotifications from './ScopeNotifications';

interface Props {
    scopes?: {}[];
}

class NotificationsContent extends Component<Props> {
    render() {
        // @ts-expect-error $TSFixMeError: Property 'notificationType' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { scopes, notificationType, ...others } = this.props;

        return (
            <ContentWrapper data-test-notification-type={notificationType}>
                {/* @ts-expect-error $TSFixMeError: JSX element type 'ScopeNotifications' does not have any construct or call signatures. */}
                {map((a) => <ScopeNotifications key={(a as $TSFixMe).profileId} {...others} {...a} />)(scopes)}
            </ContentWrapper>
        );
    }
}

export default connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        scopes: getSortedScopes,
    })
)(NotificationsContent);
